/* eslint-disable arrow-body-style */
/* eslint-disable react/button-has-type */
/* eslint-disable radix */
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Search, Plus, Eye, Layers, Edit, Trash2, ChevronDown, FileText } from 'lucide-react';
import CreateSourceDialog from "./form";
import ResponsiveTable from '../../../components/Table/Responsivetable';
import adminServices from '../../../services/adminServices';
import useDebounce from '../../../hooks/useDebounce';
import ViewSourceModal from './ViewSourceModal';
import Snackbar from '../../../components/snackbar/snackbar';



const Sources = () => {
  const { t } = useTranslation();
  const [sources, setSources] = useState([]);
  const {userInfo} = useSelector((state) => state);
  

  const [searchQuery, setSearchQuery] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [statusFilter, setStatusFilter] = useState('');
  const [openCreateSource, setOpenCreateSource] = useState(false);
  const [editSource, setEditSource] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const debouncedSearch = useDebounce(searchQuery, 500);

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [viewSourceOpen, setViewSourceOpen] = useState(false);
  const [viewSourceId, setViewSourceId] = useState(null);
  const [viewSourceData, setViewSourceData] = useState(null);
  const [loadingSource, setLoadingSource] = useState(false);
  const [viewSourceError, setViewSourceError] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState(null);
  
  const [assessmentTypeList, setAssessmentTypeList] = useState([]);
  
  useEffect(() => {
    getAssessmentTypeList();
  }, [])

  useEffect(() => {
    if (viewSourceOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [viewSourceOpen]);

  const getAssessmentSource = useCallback(async () => {
    setLoading(true);
    try {
      const result = await adminServices.getAssessmentSource(
        debouncedSearch,
        categoryFilter,
        statusFilter,
        page,
        pageCount
      );

      if (result.ok) {
        setSources(result.data.data || []);
        setTotalPages(result.data.pagination?.totalPages || 0);
        setTotalCount(result.data.pagination?.total || 0);
      }
    } catch (error) {
      console.error('Failed to fetch assessments:', error);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, categoryFilter, statusFilter, page, pageCount]);

  useEffect(() => {
    getAssessmentSource();
  }, [getAssessmentSource]);

  // const getDifficultyBadgeClass = (difficulty) => {
  //   const difficultyLower = difficulty?.toLowerCase();

  //   if (difficultyLower === 'easy') {
  //     return 'bg-[#FEF9C3] text-yellow-700';
  //   }

  //   if (difficultyLower === 'medium') {
  //     return 'bg-[#FEF9C3] text-yellow-700';
  //   }

  //   if (difficultyLower === 'hard') {
  //     return 'bg-[#FEF9C3] text-yellow-700';
  //   }

  //   return 'bg-[#FEF9C3] text-yellow-700';
  // };


  const getDifficultyBadgeClass = (difficulty) => {
    const difficultyLower = difficulty?.toLowerCase();
    if (difficultyLower === 'easy') {
      return 'bg-green-100 text-green-700';
    }
    if (difficultyLower === 'medium') {
      return 'bg-yellow-100 text-yellow-700';
    }
    if (difficultyLower === 'hard') {
      return 'bg-red-100 text-red-700';
    }
    if (difficultyLower === 'mixed') {
      return 'bg-blue-100 text-blue-700';
    }
    return 'bg-gray-100 text-gray-700';
  };

  const getCategoryColor = () => {
    return 'bg-[#F1F9F5] text-black';
  };

  const normalizeSource = (data) => {
    if (!data) return null;
    return {
      ...data,
      chapters: Array.isArray(data.chapters) ? data.chapters : [],
    };
  };

  const fetchViewSource = useCallback(async (id) => {
    if (!id) return;
    setLoadingSource(true);
    setViewSourceError(null);
    try {
      const response = await adminServices.getAssessmentSourceBasedonId(id);
      setViewSourceData(normalizeSource(response?.data));
    } catch (error) {
      console.error('Error fetching source details:', error);
      setViewSourceError('Failed to load source details.');
      setViewSourceData(null);
    } finally {
      setLoadingSource(false);
    }
  }, []);

     const getAssessmentTypeList = async () => {
      try {
        const result = await adminServices.getAssessmentTypeDropdown();
        if (result && result.ok) {
          const list = result.data?.data || result.data || [];
           setAssessmentTypeList(list.filter(item => item.is_active));
        }
      } catch (error) {
        console.error('Assessment Type dropdown API not ready:', error);
        setAssessmentTypeList([]);
      }
    };

  useEffect(() => {
    if (viewSourceOpen && viewSourceId) {
      fetchViewSource(viewSourceId);
    }
  }, [viewSourceOpen, viewSourceId, fetchViewSource]);

  const handleView = (id) => {
    setViewSourceId(id);
    setViewSourceOpen(true);
  };

  const handleEdit = async (id) => {
    const result = await adminServices.getAssessmentSourceBasedonId(id)
    setEditSource(result.data);
    setOpenCreateSource(true)
  };

  const handleDelete = (source) => {
    setSelectedSource(source);
    setDeleteModalOpen(true);
  };
  const confirmDelete = async () => {
    if (!selectedSource) return;

    try {
      setDeleteLoading(true);

      const result = await adminServices.deleteSourceByid(selectedSource.id);
      console.log(result, "resultresult");

      if (result?.ok) {
        setSnackbarTitle(result.data.message);
        setSnackbarOpen(true);
        setDeleteModalOpen(false);
        setSelectedSource(null);
        getAssessmentSource();
      }
    } catch (error) {
      console.error("Error deleting source:", error);
      setSnackbarTitle("Failed to delete source");
      setSnackbarOpen(true);
    } finally {
      setDeleteLoading(false);
    }
  };


  const handleChapters = (id) => {
    navigate(`/app/source-chapters/${id}`);
  };

    const handleNavigateExport = () => {
    navigate('/app/exportdata');
  };


  const handleCreateSource = () => {
    setOpenCreateSource(true);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newSize) => {
    setPageCount(newSize);
    setPage(1);
  };

  const columns = [
    {
      label: t('Source Name'),
      key: 'title',
      render: (row) => (
        <div>
          <div className="text-sm font-semibold text-gray-900">
            {row.title}
          </div>
          {row.description && (
            <div className="text-sm text-gray-500 mt-0.5">
              {row.description}
            </div>
          )}
        </div>
      ),
    },
    {
      label: t('Category'),
      key: 'category',
      // accessor: (row) => row?.type,
      // cellClassName: 'bg-gray-600 text-black',
      render: (row) => (
        <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium uppercase ${getCategoryColor()}`}>
          {row?.type}
        </span>
      ),
    },
    {
      label: t('Difficulty'),
      key: 'difficulty',
      render: (row) => (
        <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium uppercase ${getDifficultyBadgeClass(row?.complexity_level)}`}>
          {row.complexity_level || 'Medium'}
        </span>
      ),
    },
    {
      label: t('Chapters'),
      key: 'chapters',
      render: (row) => (
        <div className="flex justify-start pl-2">
          <span className="px-3 py-1 border rounded-md text-sm text-gray-900 font-medium">
            {parseInt(row.chapters_count) || 0}
          </span>
        </div>
      ),
    },
    {
      label: t('Questions'),
      key: 'questions',
      render: (row) => (
        <div className="flex justify-start items-center gap-1.5 pl-2">
          <FileText size={16} className="text-gray-400" />
          <span className="text-sm text-gray-900 font-medium">
            {row.questions_count || 0}
          </span>
        </div>
      ),
    },

  {
  label: t('Actions'),
  key: 'actions',
  headerClassName: 'text-center',
  cellClassName: 'text-center',
  render: (row, index, onActionClick) => (
    <div className="flex items-center justify-center gap-2 relative left-[-6px]">
      <button
        id={`btn-view-source-${row.id}`}
        onClick={() => onActionClick('view', row)}
        className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
      >
        <Eye size={18} />
      </button>

      <button title="Chapters"
        id={`btn-chapters-source-${row.id}`}
        onClick={() => onActionClick('chapters', row)}
        className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
      >
        <Layers size={18} />
      </button>


      {userInfo?.id === row?.related_created_user_id &&
      <>
        <button
          id={`btn-edit-source-${row.id}`}
          onClick={() => onActionClick('edit', row)}
          className="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-150"
        >
          <Edit size={18} />
        </button>
     

        <button
          id={`btn-delete-source-${row.id}`}
          onClick={() => onActionClick('delete', row)}
          className="p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors duration-150"
        >
          <Trash2 size={18} />
        </button></>}
      
    </div>
  ),
},
  ];

  const handleActionClick = (action, source) => {
    switch (action) {
      case 'view':
        handleView(source.id);
        break;
      case 'edit':
        handleEdit(source.id);
        break;
      case 'delete':
        handleDelete(source);
        break;
      case 'chapters':
        handleChapters(source.id);
        break;
      default:
        break;
    }
  };

  const schema = localStorage.getItem('tenant_kss') || 'public';

  return (
    <>
      <div className="min-h-screen bg-gray-50 p-4 sm:p-6 mt-12 lg:p-8">
        <div className="mx-auto">
          {/* Header Section */}
          <div className="mb-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  {t('Sources & Chapters')}
                </h2>
                <p className="mt-1 text-sm text-gray-500">
                  {t('Organize educational content by sources and chapters')}
                </p>
              </div>
              <button
                id="btn-create-source"
                onClick={handleCreateSource}
                className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm"
              >
                <Plus size={20} className="mr-2" strokeWidth={2.5} />
                {t('Create Source')}
              </button>
            </div>
          </div>

          {/* Filters Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Search Bar */}
              <div className="relative">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    id="search-input"
                    type="text"
                    placeholder={t('Search sources...')}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                </div>
              </div>

              {/* Category Filter */}
              <div>
                <div className="relative">
                  <select
                    id="category-select"
                    value={categoryFilter}
                    onChange={(e) => setCategoryFilter(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm appearance-none bg-white"
                  >
                    <option value="">{t('All Categories')}</option>
                    {assessmentTypeList.map((item) => (
                      <option key={item.id} value={item.code}>
                        {t(item.description || item.code)}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={20} />
                </div>
              </div>
               {schema !== 'public' &&
              <div>
                <button id="btn-create-source"
                onClick={handleNavigateExport}
                className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm">Export Data</button>
                
              </div>}
            </div>
          </div>

          {/* Table Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <ResponsiveTable
              columns={columns}
              data={sources}
              loading={loading}
              onActionClick={handleActionClick}
              emptyStateComponent={() => {
                const isSearchOrFilterActive =
                  searchQuery.trim() !== '' ||
                  categoryFilter !== '' ||
                  statusFilter !== '';

                return (
                  <div className="text-center py-20">
                    <div className="flex justify-center mb-4">
                      <svg
                        className="h-16 w-16 text-gray-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={1.5}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        />
                      </svg>
                    </div>

                    <p className="text-gray-500 text-sm mb-4">
                      {isSearchOrFilterActive
                        ? t('No Sources found')
                        : t('No Sources found')}
                    </p>

                    {!isSearchOrFilterActive && (
                      <button
                        id="btn-create-first-source"
                        onClick={handleCreateSource}
                        className="inline-flex items-center justify-center px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-md border border-gray-300 transition-colors duration-150 shadow-sm"
                      >
                        {t('Create Your First Source')}
                      </button>
                    )}
                  </div>
                );
              }}
            />

            {sources.length > 0 && (
              <div className="px-4 py-3 border-t border-gray-200 sm:px-6">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  {/* Results info */}
                  <div className="text-sm text-gray-700">
                    {t('Showing')} <span className="font-medium">{(page - 1) * pageCount + 1}</span> {t('to')}{' '}
                    <span className="font-medium">
                      {Math.min(page * pageCount, totalCount)}
                    </span>{' '}
                    {t('of')} <span className="font-medium">{totalCount}</span> {t('results')}
                  </div>

                  {/* Pagination controls */}
                  <div className="flex items-center gap-2">
                    {/* Rows per page */}
                    <select
                      id="select-rows-per-page"
                      value={pageCount}
                      onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                      className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>

                    {/* Previous button */}
                    <button
                      id="btn-pagination-previous"
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                      className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                    >
                      {t('Previous')}
                    </button>

                    {/* Page numbers */}
                    {totalPages > 1 && (
                      <div className="hidden sm:flex items-center gap-1">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNum;
                          if (totalPages <= 5) {
                            pageNum = i + 1;
                          } else if (page <= 3) {
                            pageNum = i + 1;
                          } else if (page >= totalPages - 2) {
                            pageNum = totalPages - 4 + i;
                          } else {
                            pageNum = page - 2 + i;
                          }

                          return (
                            <button
                              key={i}
                              id={`btn-page-${pageNum}`}
                              onClick={() => handlePageChange(pageNum)}
                              className={`px-3 py-1.5 border rounded-lg text-sm font-medium transition-colors duration-150 ${page === pageNum
                                ? 'bg-indigo-600 text-white border-indigo-600'
                                : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                                }`}
                            >
                              {pageNum}
                            </button>
                          );
                        })}
                      </div>
                    )}

                    <button
                      id="btn-pagination-next"
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === totalPages || totalPages === 0}
                      className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
                    >
                      {t('Next')}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <ViewSourceModal
            open={viewSourceOpen}
            loading={loadingSource}
            sourceData={viewSourceData}
            error={viewSourceError}
            onRetry={() => fetchViewSource(viewSourceId)}
            onClose={() => {
              setViewSourceOpen(false);
              setViewSourceId(null);
              setViewSourceData(null);
              setViewSourceError(null);
            }}
          />
        </div>
      </div>

      {deleteModalOpen && (
        <div id="delete-source-confirm-modal" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Delete Source
            </h3>

            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to delete this source? This action cannot be undone.
            </p>

            <div className="flex justify-end gap-3">
              <button
                id="btn-delete-modal-cancel"
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedSource(null);
                }}
                className="px-4 py-2 text-sm border border-gray-300 rounded-md"
              >
                Cancel
              </button>

              <button id="btn-delete-modal-confirm" onClick={confirmDelete} disabled={deleteLoading} className={`px-4 py-2 text-sm text-white rounded-md flex items-center justify-center min-w-[90px] ${deleteLoading ? "bg-red-400 cursor-not-allowed" : "bg-red-600 hover:bg-red-700"}`}>
                {deleteLoading ? (
                  <span className="flex items-center gap-2">
                    <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                    </svg>
                    Deleting...
                  </span>
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <CreateSourceDialog
        open={openCreateSource}
        editdetails={editSource}
        onClose={() => {
          setOpenCreateSource(false);
          setEditSource('');
          getAssessmentSource();
        }}
        onNotify={(message) => {
          setSnackbarTitle(message);
          setSnackbarOpen(true);
        }}
        assessmentTypeList={assessmentTypeList}
      />

      <Snackbar
        open={snackbarOpen}
        snackbarTitle={snackbarTitle}
        close={() => setSnackbarOpen(false)}
      />

    </>
  );
};

export default Sources;